import React from "react";
import { TextInShapeProps } from "./textInShape.model";
import { FontIcon } from "@companion-core/shared/app/Components/FontIcon";
import "@companion-core/web/src/Assets/Styles/scss/textInShape.scss";

export const TextInShape = ({
  ariaLabel,
  testID,
  shape = "default",
  text,
  icon,
  size = "default",
  value,
  selected = false,
  onClick,
}: TextInShapeProps) => {
  const dataTestId =
    typeof value === "string" && !testID.includes(value) ? `${testID}-${value}` : testID;
  return (
    <button
      data-testid={dataTestId}
      aria-label={ariaLabel}
      className={`shape shape--${shape} shape-size--${size} ${selected && "shape--selected"}`}
      onClick={() => onClick && onClick(value)}>
      {icon && <FontIcon aria-hidden="true" name={icon} size={24} />}
      <span aria-hidden="true" className="shape__text body-text-6">
        {text}
      </span>
    </button>
  );
};
